import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { environment } from '@env/environment';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss']
})
export class FormErrorComponent {

  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() item: string;
  @Input() format: string;
  @Input() exists = false;
  @Input() notExists = false;
  @Input() required = false;
  @Input() interval = false;
  @Input() expired = false;
  @Input() max = false;
  @Input() min = false;
  @Input() email = false;
  @Input() female = false;
  @Input() notAllowed = false;
  @Input() mustBeEmpty = false;
  @Input() onlyIcon = false;
  @Input() rangeEqual = false;

  visualFacility: boolean = environment.visualFacility;

  constructor(
  ) { }

  getControl(): AbstractControl {
    return this.form.get(this.controlName) ;
  }

}
